/**
 * Application configuration for the player project
 * @type {{develop: boolean}}
 */

module.exports = {

    // Player config
    playerElementId: 'starzplayer', // The ID of the div of the client
    environment: 'production', // Possible values: 'development', 'test', production'.
    esbUrl: 'https://ev-api.aws.playco.com/api/v0.2/', // FIXME The last / should be removed, and added to the path where this is used
    recEngineUrl: 'https://ev-api.aws.playco.com/api/v1.0/',

    // HTTPS
    httpCdnUrl: 'http://ev-img-cdn-lb.shoq.com.pk',
    httpsCdnUrl: 'https://ev-cdn-lb.mobily.com.sa',
    httpCdnUrl2: 'http://mena-cdn-lb.aws.playco.com',
    httpsCdnUrl2: 'https://starzplay-prod-ssl.akamaized.net',
    httpJitUrl: 'http://cp-jit-cdn-lb.aws.playco.com',
    httpsJitUrl: 'https://ev-jit-cdn-lb.mobily.com.sa',
    httpJitUrl2: 'http://mena-jit-cdn-lb.aws.playco.com',
    httpsJitUrl2: 'https://starzplay-jit-prod-ssl.akamaized.net',
    httpJitUrl3: 'http://live-twist-starzplayarabia.akamaized.net',
    httpsJitUrl3: 'https://dqm86pmi24ou6.cloudfront.net'
};



// WEBPACK FOOTER //
// ./src/config.js